import { StoreModel } from "models/StoreModel";
import { Translations } from "models/Translations";
import React from "react";
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from "react-redux";
import { TranslationsActions } from 'redux/actions/TranslationActions';
import { Translate } from "infrastructure/mapping/Translate";

export interface Props {
    text: string,
    translations: Translations,
    loadTranslations: typeof TranslationsActions.loadTranslations,
    className?: string
}

class TranslatorComp extends React.Component<Props> {

    componentDidMount() {
        if (!this.props.translations) {
            this.props.loadTranslations();
        }
    }

    ready() {
        return this.props.translations
    }

    render() {
        let text = this.props.text;
        if (this.ready()) {
            text = Translate.text(this.props.translations, this.props.text);
        }
        return (
            <>
                {this.props.className &&
                    <div className={this.props.className}>
                        {text}
                    </div>
                }
                {!this.props.className &&
                    <>
                        {text}
                    </>
                }
            </>
        );
    };
}

function mapStateToProps(state: StoreModel) {
    return {
        loginUser: state.loginUser,
        translations: state.translations,
    };
}
function mapDispatchToProps(dispatch: Dispatch) {
    return {
        loadTranslations: bindActionCreators(TranslationsActions.loadTranslations, dispatch),
    };
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TranslatorComp);